import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { TaiLieu } from './tai-lieu';
import { GoogleService } from './GoogleService';
import { TaiLieuKy } from './danh-sach-tai-lieu';
import { ToastService } from '@iamsoftware/react-hooks';
const TaoTaiLieuCommand: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await GoogleService.createEmpty();
        if (!cancelled && res && res.agreementId) {
          navigate(`/quan-ly-tai-lieu/tai-lieu/${res.agreementId}`, { replace: true });
        }
      } catch (e: any) {
        console.log(e);
        ToastService.error(e.response.data.errors);
        navigate(`/quan-ly-tai-lieu/danh-sach-tai-lieu`, { replace: true });
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);
  return (<div className="p-3">Đang tạo tài liệu...</div>);
};

export default function QuanLyTaiLieu() {
  return (
    <Routes>
      <Route path="tai-lieu" element={<TaoTaiLieuCommand />} />
      <Route path="tai-lieu/:agreementId" element={<TaiLieu />} />
      <Route path="danh-sach-tai-lieu" element={<TaiLieuKy />} />
    </Routes>
  );
}
